import {h} from 'preact';

export default function TextInput({inputProps,  name, isRequired, errors}){
	return (
		<div className={`form-field form-field_gray ${errors ? 'form-field_state_error':''}`}>
			<div className="form-field__inner">
				<div className="form-field__title-row">
					<label className="form-field__title" htmlFor={inputProps.id}>{isRequired}{name}</label>
				</div>
				<div className="form-field__input-row">
					<input className="input form-field__input" type="text" {...inputProps} autoComplete="off"/>
				</div>
			</div>
		</div>
	)
}